import React from 'react';
import SubscriptionTemplate from './SubscriptionTemplate';
import { displayMessage } from './wsHelpers';
import { connect } from 'react-redux';
import {
	createPodcast,
	updatePodcast,
	deletePodcast,
	// updatePodcastListens
} from '@/redux/actions';

const WS_PODCAST_BY_HTTP = {
	CREATE: 'podcasts/POST',
	UPDATE: 'podcasts/:podcastID/PATCH',
	DELETE: 'podcasts/:podcastID/DELETE',
	LISTENS: 'listens/podcasts/:podcastID/PATCH',
};

const PodcastSubscriptions = props => {
	const {
		socket,
		children,
		currentEventId,
		createPodcast,
		updatePodcast,
		deletePodcast,
		// updatePodcastListens,
	} = props;
	const propsToSend = { ...props };
	delete propsToSend.children;

	const subscribe = () => {
		socket.emit('event/:eventID/podcasts/SUBSCRIBE', { eventID: currentEventId });
	};

	const unsubscribe = () => {
		socket.emit('event/:eventID/podcasts/UNSUBSCRIBE', { eventID: currentEventId });
	};

	const listenForCreatedPodcast = () => {
		socket.on(WS_PODCAST_BY_HTTP.CREATE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Podcast could not be created', error);
			else {
				createPodcast(data);
				displayMessage('Podcast created');
			}
		});
	};

	const listenForUpdatedPodcast = () => {
		socket.on(WS_PODCAST_BY_HTTP.UPDATE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Podcast could not be updated', error);
			else {
				updatePodcast(data);
				displayMessage('Podcast updated');
			}
		});
	};

	const listenForDeletedPodcast = () => {
		socket.on(WS_PODCAST_BY_HTTP.DELETE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Podcast could not be deleted', error);
			else {
				deletePodcast(data);
				displayMessage('Podcast deleted');
			}
		});
	};

	// const listenForUpdatedPodcastListens = () => {
	// 	socket.on(WS_PODCAST_BY_HTTP.DELETE, payload => {
	// 		const { data, error } = payload;
	// 		if (error) displayMessage('Podcast listens could not be updated', error);
	// 		else {
	// 			updatePodcastListens(data);
	// 			displayMessage('Podcast listens updated');
	// 		}
	// 	});
	// };

	const listeners = () => [
		listenForCreatedPodcast,
		listenForUpdatedPodcast,
		listenForDeletedPodcast,
		// listenForUpdatedPodcastListens,
	];

	return (
		<>
			<SubscriptionTemplate
				{...props}
				sub={subscribe}
				unsub={unsubscribe}
				listeners={listeners()}
				routes={Object.values(WS_PODCAST_BY_HTTP)}
				from="PodcastSubscriptions"
			/>
			{React.cloneElement(children, propsToSend)}
		</>
	);
};

const msp = ({ ws, auth, events }) => ({
	socket: ws.socket,
	currentEventId: events.currentEvent.id,
});

const mdp = dispatch => ({
	createPodcast: podcast => dispatch(createPodcast(podcast)),
	updatePodcast: podcast => dispatch(updatePodcast(podcast)),
	deletePodcast: podcastID => dispatch(deletePodcast(podcastID)),
	// updatePodcastListens: podcast => dispatch(updatePodcastListens(podcast)),
});

export default connect(msp, mdp)(PodcastSubscriptions);
